// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  BASE_URL: 'https://api-dev.gogomoneymaker.com',
  TRY_MODE_URL: 'https://try.gogomoneymaker.com',
  IS_TRY_MODE: false,
  TRY_MODE_EMAIL_ADDRESS: 'test.user@email.com',
  TRY_MODE_PASSWORD: 'password',
  STRIPE_KEY: 'pk_test_51QnSX7CNdkmQWahr98uz2AVw5IIgCvjLLloxjOvPH1k6aSgzw4PaLsCzhzgshZyai6uHG9Qvk0bAQASaZzsca8jF0038DUKodu'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
